@let railMenu = railEntries(!!(tenantId | appCanPurgeTeamItem));
@if (railMenu) {
  <app-rail-menu
    [entries]="railMenu"
    [checkColumn]="personalInbox"
    [submenus]="{ 'new-container': newFolderForm }"
    (selected)="runRailEntry($event)"
  />
  <ng-template #newFolderForm>
    <app-message-folder-quick-form
      class="quick-form"
      [folder]="railNewFolder"
      [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
      [mailboxTenantId]="tenantId"
      (close)="handleClose()"
    (more)="handleQuickDetails($event)" />
  </ng-template>
} @else {
        @if (!(['sent', 'draft', 'scheduled', 'all_folders', 'search_results'] | includesBy : sidebarFilterKey)) {
          <app-context-menu-item
            title="Mark all as read"
            [close]="true"
            (execute)="readAll()"
            />
        }

        @if (sidebarFilterKey === 'scheduled') {
          <app-context-menu-item
            title="Send all"
            [close]="true"
            (execute)="sendAll()"
            />
        }

        @if (sidebarFilterKey === 'all_folders') {
          <app-context-menu-item
            title="Add new folder"
            >
            <app-message-folder-quick-form
              class="quick-form"
              [folder]="containerStitchItem"
              [autofocus]="true" [showMore]="true" [showCancel]="true" [inline]="true"
              [mailboxTenantId]="tenantId"
              (close)="handleClose()"
              (more)="handleQuickDetails($event)" />
            </app-context-menu-item>
          }

          @if (!(['sent', 'draft', 'search_results'] | includesBy : sidebarFilterKey)) {
            <app-context-menu-divider />
          }

          @if (sidebarFilterKey === 'flagged') {
            <app-context-menu-item
              title="Unflag all"
              [close]="true"
              (execute)="unFlagAll()"
              />
          }

          @if (sidebarFilterKey === 'followed') {
            <app-context-menu-item
              [title]="followUpWording.removeAllFollowUps()"
              [close]="true"
              (execute)="unFollowAll()"
              />
          }

          @if (sidebarFilterKey === 'snoozed') {
            <app-context-menu-item
              title="Unsnooze all"
              [close]="true"
              (execute)="unSnoozeAll()"
              />
          }

          @if ((['spam', 'archived'] | includesBy: sidebarFilterKey)) {
            <app-context-menu-item
              title="Delete all"
              [close]="true"
              (execute)="deleteAll()"
              />
          }

          @if (sidebarFilterKey === 'deleted') {
            <app-context-menu-item
              title="Empty trash"
              [disabled]="!(tenantId | appCanPurgeTeamItem)"
              [note]="PURGE_REFUSED_REASON"
              [matTooltip]="(tenantId | appCanPurgeTeamItem) ? '' : PURGE_REFUSED_REASON"
              [close]="true"
              (execute)="emptyTrash()"
              />
          }

          @if ((['flagged', 'snoozed', 'followed', 'spam'] | includesBy : sidebarFilterKey)) {
            <app-context-menu-divider />
          }

          @if (rail) {
            <app-context-menu-item title="View settings…" [close]="true" (execute)="runRailEntry('settings')" />
          } @else if (!(['deleted', 'archived'] | includesBy: sidebarFilterKey)) {
            <app-context-menu-item
              title="Settings"
              [close]="true"
              (execute)="openSettings()"
              />
          }

}
